<form class="search-orders" [formGroup]="searchForm" autocomplete="off">
  <div class="row no-gutters py-2 px-2">
    <div class="col-auto">
      <app-search-text
        formElementId="patientMrn"
        label="MRN"
        [parentFormGroup]="searchForm"
      ></app-search-text>
    </div>
    <div class="col-auto">
      <app-search-text
        formElementId="accessionNumber"
        label="Accession Number"
        [parentFormGroup]="searchForm"
      ></app-search-text>
    </div>
    <div class="col-auto">
      <app-date
        formElementId="patientBirthDate"
        label="DOB"
        [parentFormGroup]="searchForm"
        [isFilteringFutureDates]="true"
      >
      </app-date>
    </div>
    <div class="col-auto">
      <app-search-text
        formElementId="patientFirstName"
        label="First Name"
        [parentFormGroup]="searchForm"
      ></app-search-text>
    </div>
    <div class="col-auto">
      <app-search-text
        formElementId="patientLastName"
        label="Last Name"
        [parentFormGroup]="searchForm"
      ></app-search-text>
    </div>
    <div class="col-auto">
      <app-date
        formElementId="studyDate"
        label="Study Date"
        [parentFormGroup]="searchForm"
        [isFilteringFutureDates]="true"
      >
      </app-date>
    </div>
    <div class="col-auto submit-search-button">
      <button
        mat-flat-button
        color="primary"
        type="submit"
        (click)="onSearchSubmit()"
      >
        Search
      </button>
    </div>
    <div class="col-auto clear-search-button">
      <button
        *ngIf="searchForm.dirty"
        type="button"
        (click)="onSearchClear()"
        mat-icon-button
        matTooltip="Clear search"
        matTooltipShowDelay="500"
      >
        <fa-icon class="primary" [icon]="['fas', 'circle-xmark']"></fa-icon>
      </button>
    </div>
  </div>
</form>
